import { render, staticRenderFns } from "./ObjectCard.vue?vue&type=template&id=ea64a9a6&scoped=true&"
import script from "./ObjectCard.vue?vue&type=script&lang=js&"
export * from "./ObjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCard.vue?vue&type=style&index=0&id=ea64a9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea64a9a6",
  null
  
)

export default component.exports